
import React from "react";
import "../style/recentnews.css";
import treeIncident from "../parm_assets/tree_incident.jpg"; // replace with your actual image
import treeClimb from "../parm_assets/tree_climb.jpeg"; // replace with your actual image
import treeCare from "../parm_assets/tree_care.jpg"; // replace with your actual image
import infoIcon from "../parm_assets/tree_icons.png";

const NewsPage = () => {
  return (
    <div className="news-section">
      <div className="news-header">
        <div>
          <p className="news-subtitle">
            <img src={infoIcon} alt="icon" className="tree-icon" />
            RECENT NEWS</p>
          <h1>Find Out PArM’s Latest News</h1>
        </div>
         <a href="/news-parm" className="read-more">
        <button className="all-news-btn">All News →</button>
        </a>
      </div>

      <div className="news-grid">
        {/* Left large card */}
        <div className="news-card large">
          <img src={treeIncident} alt="Tree Failure" className="news-img" />
          <div className="news-content">
            <div className="news-meta">
              <span>📅 May 8, 2024</span>
              <span>👤 By admin</span>
            </div>
            <h3>TREE FAILURE INCIDENT</h3>
            <p>
              Kuala Lumpur, Malaysia – Persatuan Arborist Malaysia (PArM)
              extends its condolences to the victims affected by the fallen tree
              incident that occurred yesterday, May 7, 2024, near Jalan Sultan
              Ismail, Kuala Lumpur. Our thoughts are with those impacted.
            </p>
            <a href="/newsDetailPage" className="read-more">
              Read More →
            </a>
          </div>
        </div>

        {/* Right small cards */}
        <div className="right-cards">
          <div className="news-card small">
            <img src={treeClimb} alt="Tree Climbing" className="news-img" />
            <div className="news-content">
              <div className="news-meta">
                <span>📅 May 6, 2024</span>
                <span>👤 By admin</span>
              </div>
              <h3>2024 ASIA PACIFIC TREE CLIMBING CHAMPIONSHIP</h3>
              <p>
                TREE CLIMBING CHAMPIONSHIP Press Release: The Asia-Pacific Tree
                Climbing Championship 2024 will take place in Kuantan, Pahang.
              </p>
              <a href="#" className="read-more">
                Read More →
              </a>
            </div>
          </div>

          <div className="news-card small">
            <img src={treeCare} alt="Tree Care" className="news-img" />
            <div className="news-content">
              <div className="news-meta">
                <span>📅 June 14, 2017</span>
                <span>👤 By The Star Online</span>
              </div>
              <h3>“Grow Skill To Care For Trees, Says Expert”</h3>
              <p>
                Trees provide social, communal, environmental, and economic
                benefits to their surrounding areas.
              </p>
              <a href="#" className="read-more">
                Read More →
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsPage;
